/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Payload to create a new notification
 * @export
 * @interface CreateNotificationRequest
 */
export interface CreateNotificationRequest {
    /**
     * User this notification is for
     * @type {number}
     * @memberof CreateNotificationRequest
     */
    userId: number;
    /**
     * Type of resource
     * @type {string}
     * @memberof CreateNotificationRequest
     */
    resourceType: string;
    /**
     * ID of the resource
     * @type {string}
     * @memberof CreateNotificationRequest
     */
    resourceId: string;
    /**
     * Human-readable notification message
     * @type {string}
     * @memberof CreateNotificationRequest
     */
    message: string;
    /**
     * Additional event-specific data
     * @type {{ [key: string]: any; }}
     * @memberof CreateNotificationRequest
     */
    metadata?: { [key: string]: any; } | null;
}

/**
 * Check if a given object implements the CreateNotificationRequest interface.
 */
export function instanceOfCreateNotificationRequest(value: object): value is CreateNotificationRequest {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('resourceType' in value) || value['resourceType'] === undefined) return false;
    if (!('resourceId' in value) || value['resourceId'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function CreateNotificationRequestFromJSON(json: any): CreateNotificationRequest {
    return CreateNotificationRequestFromJSONTyped(json, false);
}

export function CreateNotificationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateNotificationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'],
        'resourceType': json['resourceType'],
        'resourceId': json['resourceId'],
        'message': json['message'],
        'metadata': json['metadata'] == null ? undefined : json['metadata'],
    };
}

export function CreateNotificationRequestToJSON(json: any): CreateNotificationRequest {
    return CreateNotificationRequestToJSONTyped(json, false);
}

export function CreateNotificationRequestToJSONTyped(value?: CreateNotificationRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': value['userId'],
        'resourceType': value['resourceType'],
        'resourceId': value['resourceId'],
        'message': value['message'],
        'metadata': value['metadata'],
    };
}

